/*
 * @Author: liujunhong
 * @Date: 2022-12-08
 * @Desc:
 */

export default {
  state: {
    count: 0
  },
  reducers: {
    setCount(state, payload) {
      return {...state, count: payload}
    }
  },
  effects: (dispatch) => ({}),
};